import { validateEnum, validateArray } from "../core/Helpers";
export var GooglePayCardAuthMethodObj = {
    PAN_ONLY: "PAN_ONLY",
    CRYPTOGRAM_3DS: "CRYPTOGRAM_3DS",
};
export var validateGooglePayCardAuthMethod = function (googlePayCardAuthMethod) {
    return validateEnum(googlePayCardAuthMethod, GooglePayCardAuthMethodObj);
};
export var validateGooglePayCardAuthMethodArray = function (googlePayCardAuthMethodArray) {
    return validateArray(googlePayCardAuthMethodArray, validateGooglePayCardAuthMethod);
};
